import { availableInHoursMinutesOrDays } from "@faire/help-center-utils/lib/dateInTimeZone";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
export var FormattedAvailableTime = function FormattedAvailableTime(_ref) {
  var supportType = _ref.supportType,
    color = _ref.color;
  var _availableInHoursMinu = availableInHoursMinutesOrDays(supportType),
    time = _availableInHoursMinu.time,
    unit = _availableInHoursMinu.unit;
  var isLessThanOneHour = unit === "minutes";
  if (!time) {
    return null;
  }
  if (isLessThanOneHour) {
    return /*#__PURE__*/React.createElement(Typography, {
      color: color
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "F3qPNJ",
      defaultMessage: "{availableMinTime, plural, one {Available in # min} other {Available in # mins}}",
      values: {
        availableMinTime: time
      }
    }));
  }
  if (unit === "hours") {
    return /*#__PURE__*/React.createElement(Typography, {
      color: color
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "jSjFuF",
      defaultMessage: "{availableHourTime, plural, one {Available in # hour} other {Available in # hours}}",
      values: {
        availableHourTime: time
      }
    }));
  }
  return /*#__PURE__*/React.createElement(Typography, {
    color: color
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "7WN4gS",
    defaultMessage: "{availableDayTime, plural, one {Available in # day} other {Available in # days}}",
    values: {
      availableDayTime: time
    }
  }));
};